/**
 * Iter 69 — Source-vendor scope helpers.
 *
 * When a customer arrives via a vendor's microsite (`/v/:slug`) we stash the
 * vendor's id + name + slug in localStorage so the global "Browse Cars"
 * header link can auto-filter the Browse page to that vendor's fleet only.
 *
 * Cleared by:
 *   • Clicking "Show all vendors" on the Browse vendor-scope chip
 *   • Logging out
 *   • Hitting the home page (logo) — explicit "I'm done shopping at this vendor"
 *
 * Why localStorage and not the URL?
 * The customer might bounce around several pages on the platform (CarDetail,
 * Browse, Compare, etc.) and we want the vendor scope to be sticky across
 * that whole session-like flow. URL-only state would drop the scope the
 * moment they click an internal nav link that doesn't carry the param.
 */

const ID_KEY = "rentalcar:source_vendor_id";
const NAME_KEY = "rentalcar:source_vendor_name";
const SLUG_KEY = "rentalcar:source_vendor_slug";  // already set elsewhere — read here

export function readSourceVendor() {
  if (typeof window === "undefined") return null;
  try {
    const id = window.localStorage.getItem(ID_KEY);
    if (!id) return null;
    return {
      id,
      name: window.localStorage.getItem(NAME_KEY) || "",
      slug: window.localStorage.getItem(SLUG_KEY) || "",
    };
  } catch (_e) {
    return null;
  }
}

export function clearSourceVendor() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(ID_KEY);
    window.localStorage.removeItem(NAME_KEY);
    // We keep the slug because attribution-on-booking still needs it; it
    // expires naturally when the next microsite visit overwrites it OR
    // when the customer logs out (see auth.jsx logout).
  } catch (_e) { /* ignore */ }
}
